import type { Images } from '../../imageType'

export type ImageError = React.SyntheticEvent<HTMLImageElement, Event> & {
  target: HTMLImageElement
}

export const handleError = (event: ImageError, zoomSrc: Images['zoomSrc']) => {
  if (zoomSrc && event.target?.src) {
    event.target.src = zoomSrc
  }
}

export const isLargeJump = (currentIndex: number, previousIndex: number) => {
  const [x, y] = [currentIndex, previousIndex].sort((a, b) => a - b)
  return x + 1 !== y
}
